export default __webpack_public_path__ + "maps-examples-camera-animators-1200-aaf08e2af65bd1228f041ba1fe55347b.webp";